import { Button, FormControl, Grid, TextField } from '@mui/material'
import React from 'react'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather'

export const ModalExpenses = ({useFetchInit}) => {

  const {
    //------------- Generales
    //------------- globalStates
    globalStates,
    //------------- Helpers
    Helpers,
    //------------- Formularios
    Forms,
    //------------- FetchData
    FetchData,

    defaultData,
    
    //------------- Actions
    Actions
  } = useFetchInit

  const {modalOpeningMode} = globalStates

  const {FormExpenses:{formState, onInputChange, onInputChangeForNumber}} = Forms

  const {handleClickCloseModal, onSubmitFormExpenses} = Actions

  return (
    <>
      <form onSubmit={onSubmitFormExpenses}>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth> 
              <label htmlFor="gasto_fecha">* Fecha del gasto</label>
              <TextField
                  id='gasto_fecha'
                  name='gasto_fecha'
                  value={ formState.gasto_fecha }
                  onChange={ onInputChange }
                  size='small'
                  placeholder='Fecha'
                  hiddenLabel
                  type='date'
                  variant={ 'outlined' }
                  InputProps={{
                      readOnly: (modalOpeningMode === 'READONLY') ? true : false 
                  }}
                  required
              />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth> 
              <label htmlFor="gasto_monto">* Monto en Quetzales</label>
              <TextField
                  id='gasto_monto'
                  name='gasto_monto'
                  value={ formState.gasto_monto }
                  onChange={ onInputChangeForNumber }
                  size='small'
                  placeholder='Monto del cargo'
                  hiddenLabel
                  type='text'
                  variant={ 'outlined' }
                  InputProps={{
                      readOnly: (modalOpeningMode === 'READONLY') ? true : false 
                  }}
                  required
              />
          </FormControl>
        </Grid>
      </Grid>

      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FormControl fullWidth> 
                <label htmlFor="gasto_descripcion">* Descripcion del gasto</label>
                <TextField
                    id='gasto_descripcion'
                    name='gasto_descripcion'
                    value={ formState.gasto_descripcion }
                    onChange={ onInputChange }
                    size='small'
                    placeholder='Descripcion del gasto'
                    hiddenLabel
                    multiline
                    rows={5}
                    type='text'
                    variant={ 'outlined' }
                    InputProps={{
                        readOnly: (modalOpeningMode === 'READONLY') ? true : false 
                    }}
                    required
                />
            </FormControl>
          </Grid>
        </Grid>

        <div className="border-bottom border-secondary "></div>

        <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>                
            <Grid item xs={12}>
                <div className="text-center">
                    <Button 
                        startIcon={<ArrowLeftCircle/>}
                        variant="contained"
                        type="button" 
                        className='btn-round'
                        color='warning'
                        onClick={() => handleClickCloseModal(false, 'EDIT')} 
                        sx={{ marginRight: 1, marginLeft: 1, marginTop: 3 }}
                    >
                        Volver
                    </Button>
                    <Button
                          endIcon={<ArrowRightCircle/>}
                          variant="contained"
                          type="submit"
                          className='btn-round'
                          color='primary'
                          sx={{ marginRight: 1, marginLeft: 1, marginTop: 3 }}
                      >
                          Guardar
                    </Button>
                </div>
            </Grid>
        </Grid>

      </form>
    </>

  )
}
